import { defineStore } from "pinia";
import GeneralClass from "@/classes/general.js";

export const useRememberStore = defineStore('remember', {
    state: () => ({
        listOfPages: [],
    }),
    getters: {},
    actions: {
        addPage(name) {
            this.listOfPages.push({pageName: name});
        },
        removePage(pageName) {
            if (this.pageExists(pageName)) {
                this.listOfPages.splice(this.listOfPages.findIndex(page => page.pageName === pageName), 1);
            }
        },
        updatePage(name, field, value, expiration = null) {
            if(!this.pageExists(name)) { this.addPage(name); }
            let page = this.getPage(name);
            page[field] = value;
            page.expiration = expiration;
        },
        getFieldValue(name, field) {
            const general = new GeneralClass();

            let page = this.getPage(name);
            if (page === undefined) { return; }

            if (page.expiration !== null && general.isDateBefore(page.expiration, general.getToday(true))) {
                this.removePage(name);
                return null;
            }

            return page[field];
        },
        pageExists(pageName) {
            return this.listOfPages.findIndex(page => page.pageName === pageName) >= 0;
        },
        getPage (pageName) {
            return this.listOfPages.find(page => page.pageName === pageName);
        },
        clear() {
            this.$reset();
        },
    },
    persist: {
        storage: localStorage,
        paths: ['listOfPages'],
    },
})